export default "__VITE_ASSET__BTqoOyMw__"